export var BLOG_PAGE_ID = 'blog';
export var BLOG_POST_PAGE_ID = 'post';
export var BLOG_WIDGET_ID = 'blog_header_widget';
export var MEMBERS_PAGE_ID = 'members';
export var MEMBER_DRAFTS_ID = 'member-drafts-page';
